// FORCE VISIBILITY - Abacate Theme
// Este script garante que o conteúdo principal fica sempre visível

(function() {
  'use strict';

  // Função para forçar visibilidade
  function forceVisibility() {
    const main = document.querySelector('main#MainContent, main.content-for-layout');
    if (main) {
      // Remove qualquer display: none ou visibility: hidden
      main.style.visibility = 'visible';
      main.style.display = 'block';
      main.style.opacity = '1';
      main.style.height = 'auto';
      main.style.width = '100%';
      main.style.position = 'relative';
      main.style.zIndex = 'auto';
      main.style.overflow = 'visible';
      main.style.clip = 'auto';
      main.style.clipPath = 'none';
      
      // Restaura o conteúdo se estiver vazio
      if (main.innerHTML === '' || main.innerHTML.trim() === '') {
        console.warn('[Abacate] Main estava vazio, tentando restaurar...');
        // Se o conteúdo foi apagado, tenta recarregar a página
        // (isso é um último recurso)
      }
    }
  }

  // Executa ao carregar a página
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', forceVisibility);
  } else {
    forceVisibility();
  }

  // Executa novamente após um pequeno delay (para garantir que scripts maliciosos não bloqueiem)
  setTimeout(forceVisibility, 100);
  setTimeout(forceVisibility, 500);
  setTimeout(forceVisibility, 1000);

  // Observa mudanças no DOM para reforçar visibilidade
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'attributes' && mutation.target.tagName === 'MAIN') {
        forceVisibility();
      }
    });
  });

  const main = document.querySelector('main#MainContent, main.content-for-layout');
  if (main) {
    observer.observe(main, {
      attributes: true,
      attributeFilter: ['style', 'class'],
      subtree: false
    });
  }

  // Monitora também mudanças no innerHTML
  document.addEventListener('DOMContentLoaded', function() {
    const main = document.querySelector('main#MainContent, main.content-for-layout');
    if (main) {
      const originalInnerHTML = main.innerHTML;
      Object.defineProperty(main, 'innerHTML', {
        get: function() {
          return originalInnerHTML;
        },
        set: function(value) {
          // Impede que o innerHTML seja apagado
          if (value === '' || value.trim() === '') {
            console.warn('[Abacate] Tentativa de apagar conteúdo bloqueada');
            return;
          }
          originalInnerHTML = value;
          this.textContent = value;
        }
      });
    }
  });
})();
